<div [formGroup]="addressForm" class="address-fields">
  <!-- Address Type -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Address Type</mat-label>
      <mat-select formControlName="addressType" placeholder="Select address type" [disabled]="readonly">
        <mat-option [value]="null">-- None --</mat-option>
        <mat-option *ngFor="let type of addressTypes" [value]="type.name">
          {{ type.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Address Line 1 -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address Line 1</mat-label>
      <input matInput formControlName="addressLine1" placeholder="Enter address line 1" [readonly]="readonly">
    </mat-form-field>
  </div>

  <!-- Address Line 2 -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address Line 2</mat-label>
      <input matInput formControlName="addressLine2" placeholder="Enter address line 2" [readonly]="readonly">
    </mat-form-field>
  </div>

  <!-- Address Line 3 -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address Line 3</mat-label>
      <input matInput formControlName="addressLine3" placeholder="Enter address line 3" [readonly]="readonly">
    </mat-form-field>
  </div>

  <!-- Address Line 4 -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address Line 4</mat-label>
      <input matInput formControlName="addressLine4" placeholder="Enter address line 4" [readonly]="readonly">
    </mat-form-field>
  </div>

  <!-- Address Line 5 -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address Line 5</mat-label>
      <input matInput formControlName="addressLine5" placeholder="Enter address line 5" [readonly]="readonly">
    </mat-form-field>
  </div>

  <!-- City and State -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>City</mat-label>
      <input matInput formControlName="city" placeholder="Enter city" [readonly]="readonly">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>State/Province</mat-label>
      <input matInput formControlName="state" placeholder="Enter state or province" [readonly]="readonly">
    </mat-form-field>
  </div>

  <!-- Postal Code and Country -->
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Postal Code</mat-label>
      <input matInput formControlName="postalCode" placeholder="Enter postal code" [readonly]="readonly">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Country</mat-label>
      <input matInput formControlName="country" placeholder="Enter country" [readonly]="readonly">
    </mat-form-field>
  </div>
</div>
